<div class="container">
  <mat-list>
    <div mat-subheader>{{'printerclasses.heading' | translate}}
      <button mat-button [matMenuTriggerFor]="menu" class="actions">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="openAddPrinterClassDialog()">
          <mat-icon>add</mat-icon>{{'printerclasses.add' | translate}}
        </button>
        @if (selectedPrinterClass) {
          <button mat-menu-item (click)="openDeletePrinterClassDialog(selectedPrinterClass)">
            <mat-icon>remove</mat-icon>{{'printerclasses.remove' | translate}}
          </button>
        }
      </mat-menu>
    </div>
    <mat-selection-list #printerClazzes class="printerClasses" [multiple]="false" hideSingleSelectionIndicator="true">
      @for (class of printerClasses; track class) {
        <mat-list-option [value]="class.printerClassName"
          (click)="selectPrinterClass(class)">
          <div class="selectionLine">
            <div>
              <mat-icon>collections_bookmark</mat-icon>
            </div>
            <div class="spacer"></div>
            <div>
              {{class.printerClassName}}
            </div>
          </div>
        </mat-list-option>
      }
    </mat-selection-list>
  </mat-list>
  <app-printer-table [printerClass]="selectedPrinterClass" class="printerTable"></app-printer-table>
</div>
